import React from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import useStyles from "../styles";
import { Box, Typography } from "@material-ui/core";
import ToggleWithText from "Components/formControls/HookFields/ToggleWithText";

const TargetToggle = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const { features, disabledView } = watch();

  return (
    <Box>
      <Box
        mt={2}
        alignItems="center"
        className={disabledView ? classes.disabledView : ""}
      >
        <Typography className={classes.switchLabel}>
          Enable the ability to message on targets
        </Typography>
        <ToggleWithText
          register={register("features.toggleDetails.communication")}
          name={"features.toggleDetails.communication"}
          checked={features?.toggleDetails?.communication || false}
          defaultChecked={features?.toggleDetails?.communication || false}
        />
      </Box>
      <Box
        mt={2}
        alignItems="center"
        className={disabledView ? classes.disabledView : ""}
      >
        <Typography className={classes.switchLabel}>
          Enable the user directory
        </Typography>
        <ToggleWithText
          register={register("features.toggleDetails.myTeam")}
          name={"features.toggleDetails.myTeam"}
          checked={get(features, "toggleDetails.myTeam", false)}
          defaultChecked={get(features, "toggleDetails.myTeam", false)}
        />
      </Box>
    </Box>
  );
};
export default TargetToggle;
